// Mode values are duplicated here because the settings endpoints publish no schema the frontend
// can generate types from. Keep every mode value in this file so there is one place to replace.

export const CHANNEL_LLM_MODES = {
  ENABLED_ALL: "ENABLED_ALL",
  ENABLED_SPECIFIC_CONTACTS: "ENABLED_SPECIFIC_CONTACTS",
  DISABLED: "DISABLED",
};

// Labels use business vocabulary: a code "contact" is a client's customer.
export const CHANNEL_LLM_MODE_OPTIONS = [
  { value: CHANNEL_LLM_MODES.ENABLED_ALL, label: "All customers" },
  { value: CHANNEL_LLM_MODES.ENABLED_SPECIFIC_CONTACTS, label: "Specific customers only" },
  { value: CHANNEL_LLM_MODES.DISABLED, label: "Off" },
];

// Shown in place of a mode value this build does not know, so the row stays readable and the
// stored value is never silently reported as off.
export const UNRECOGNIZED_CHANNEL_LLM_MODE_LABEL = "Unrecognized setting";

export const isRecognizedChannelLlmMode = (mode) =>
  Object.prototype.hasOwnProperty.call(CHANNEL_LLM_MODES, mode);

// Tab-length names: the tab sits next to the full dropdown, so "Specific customers" is enough.
const CHANNEL_LLM_MODE_SHORT_LABELS = {
  [CHANNEL_LLM_MODES.ENABLED_ALL]: "All customers",
  [CHANNEL_LLM_MODES.ENABLED_SPECIFIC_CONTACTS]: "Specific customers",
  [CHANNEL_LLM_MODES.DISABLED]: "Off",
};

export const channelModeShortLabel = (mode) =>
  (isRecognizedChannelLlmMode(mode) ? CHANNEL_LLM_MODE_SHORT_LABELS[mode] : UNRECOGNIZED_CHANNEL_LLM_MODE_LABEL);

// One line under the mode dropdown saying what the mode does with the override lists below it.
export const channelModeHint = (mode, displayName) => {
  if (mode === CHANNEL_LLM_MODES.ENABLED_ALL) return "Polly replies to every customer, except anyone disabled below.";
  if (mode === CHANNEL_LLM_MODES.ENABLED_SPECIFIC_CONTACTS) return "Polly replies only to the customers enabled below.";
  if (mode === CHANNEL_LLM_MODES.DISABLED) return `Polly doesn't reply to anyone on ${displayName}.`;
  return null;
};
